/* BANDUDU · movimiento visible (capa 2, 13-oct-2026). Sin librerías.
   Agrega: título palabra por palabra, ondas en la órbita, ilustración que sigue al cursor y se desplaza al bajar,
   barra de progreso, títulos de sección que aparecen, franja de beneficios en movimiento también en escritorio.
   Si algo falla se quita html.bd-plus y todo queda visible. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || (window.Shopify && window.Shopify.designMode)) return;

  function safe(fn) {
    try { fn(); } catch (e) { root.classList.remove('bd-plus'); if (window.console) console.warn('[bd-motion-plus]', e); }
  }

  /* Dos anillos que salen de la órbita */
  function ripples() {
    var orbit = document.querySelector('.bdh-art-orbit');
    if (!orbit || orbit.querySelector('.bdp-ripple')) return;
    for (var i = 0; i < 2; i++) {
      var r = document.createElement('span');
      r.className = 'bdp-ripple';
      r.setAttribute('aria-hidden', 'true');
      orbit.appendChild(r);
    }
  }

  /* La ilustración se inclina hacia el cursor (solo con mouse) */
  function tilt() {
    var hero = document.querySelector('.bdh-hero');
    var art = document.querySelector('.bdh-hero-art');
    if (!hero || !art || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var frame = 0;
    hero.addEventListener('pointermove', function (e) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        var box = hero.getBoundingClientRect();
        var dx = (e.clientX - box.left) / box.width - 0.5;
        var dy = (e.clientY - box.top) / box.height - 0.5;
        art.style.transform = 'perspective(900px) rotateY(' + (dx * 14).toFixed(2) + 'deg) rotateX(' + (-dy * 12).toFixed(2) + 'deg) translate3d(' + (dx * 18).toFixed(1) + 'px,' + (dy * 14).toFixed(1) + 'px,0)';
      });
    });
    hero.addEventListener('pointerleave', function () { art.style.transform = ''; });
  }

  /* Barra de progreso y desplazamiento de la ilustración al bajar */
  function onScroll() {
    var bar = document.createElement('div');
    bar.className = 'bdp-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var art = document.querySelector('.bdh-hero-art');
    var ticking = false;
    function update() {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.scrollY || window.pageYOffset;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0).toFixed(4) + ')';
      if (art && y < window.innerHeight * 1.2) art.style.setProperty('--bdp-parallax', (y * 0.18).toFixed(1) + 'px');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* Títulos de sección y bloques que aparecen al llegar (solo los que están abajo al cargar) */
  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bdp-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });
    document.querySelectorAll('.bdh-section-head, .bdh-benefits + .bdh-section .bdh-section-head, .bdh-help').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) { el.classList.add('bdp-in'); return; }
      el.classList.add('bdp-reveal');
      io.observe(el);
    });
  }

  /* Chips bajo el buscador: aparecen uno tras otro */
  function chips() {
    document.querySelectorAll('.bd-chips a, .bd-chips button, .bd-chips li').forEach(function (el, i) {
      el.style.setProperty('--c', String(i));
    });
  }

  /* Franja de beneficios: si la capa 1 no la puso en movimiento (escritorio), se arma aquí repitiendo el texto */
  function marquee() {
    var slides = document.querySelectorAll('.announcement-bar__slide');
    if (slides.length !== 1) return;
    var text = slides[0].querySelector('.announcement-bar__text');
    if (!text || text.classList.contains('bd-marquee')) return;
    // 22-oct-2026: si el mensaje cabe se queda fijo; lo que se mueve solo se lee menos (NN/g).
    if (text.scrollWidth <= text.clientWidth + 1) return;
    var keep = Math.ceil(text.getBoundingClientRect().height);
    var source = text.textContent.trim();
    if (!source) return;
    var track = document.createElement('span');
    track.className = 'bd-marquee__track';
    var set = document.createElement('span');
    set.className = 'bd-marquee__item';
    text.textContent = '';
    text.appendChild(track);
    track.appendChild(set);
    // Repite el texto hasta cubrir el ancho de la barra; luego duplica el bloque para el giro sin cortes.
    var guard = 0;
    do {
      var piece = document.createElement('span');
      piece.textContent = source + ' • ';
      if (guard > 0) piece.setAttribute('aria-hidden', 'true');
      set.appendChild(piece);
      guard++;
    } while (set.getBoundingClientRect().width < text.getBoundingClientRect().width && guard < 12);
    var copy = set.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    track.appendChild(copy);
    text.style.minHeight = keep + 'px';
    text.classList.add('bd-marquee');
    text.style.setProperty('--bd-marquee-dur', Math.max(14, Math.round(set.getBoundingClientRect().width / 55)) + 's');
  }

  function init() {
    root.classList.add('bd-plus');
    safe(ripples);
    safe(tilt);
    safe(onScroll);
    safe(reveal);
    safe(chips);
    // La capa 1 decide primero si la franja no cabe (celular); esto cubre el escritorio.
    setTimeout(function () { safe(marquee); }, 60);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
